export const campusesList = {
  limit: function (cont) {
    return $(cont).data('limit') ? $(cont).data('limit') : 3
  },
  init: function () {
    $('.campuses-list').off('click');

    $('.campuses-list').each(function () {
      var $this = $(this),
        campuses = $this.find('.location'),
        campusesLen = campuses.length;

      $this.find('.more-campuses').remove();

      campusesList.showItems(this, campuses);

      if (campusesLen > campusesList.limit(this)){
        $this.append('<a href="" class="more-campuses show-more" data-title-more="More campuses" data-title-less="Less campuses">More campuses</a>');
      }
    }).on('click', '.more-campuses', function (e) {
      e.preventDefault();

      var $this = $(this),
        cont =  $this.closest('.campuses-list'),
        campuses = cont.find('.location');

      if ($this.hasClass('show-more')) {
        campusesList.showItems(cont, campuses, campuses.length);
        $this.removeClass('show-more').addClass('show-less').html($this.data('title-less'));
      } else if ($this.hasClass('show-less')){
        campusesList.showItems(cont, campuses);
        $this.removeClass('show-less').addClass('show-more').html($this.data('title-more'));
      }
    });
  },
  showItems: function (cont, campuses, limit) {
    if (!limit) {
      limit = campusesList.limit(cont);
    }
    campuses.each(function (i, v) {
      if (i + 1 <= limit) {
        $(v).show();
      } else {
        $(v).hide();
      }
    });
  }
};